import Vue from 'vue';
import accountService from '@/modules/account-service';

const ACCOUNT_REQUEST = 'ACCOUNT_REQUEST',
	ACCOUNT_SUCCESS = 'ACCOUNT_SUCCESS',
	ACCOUNT_ERROR = 'ACCOUNT_ERROR',
	UPDATE_PAYMENT_METHOD = 'UPDATE_PAYMENT_METHOD',
	GET_ESTIMATED_TAX = 'GET_ESTIMATED_TAX',
	SET_ESTIMATED_TAX = 'SET_ESTIMATED_TAX',
	SET_TAX_LOADING = 'SET_TAX_LOADING';

const state = {
	status: {},
	account: {},
	estimatedTax: null,
	loadingTaxInfo: false
};

const getters = {
	account: state => state.account,
	accountStatus: state => state.status
};

const actions = {
	[ACCOUNT_REQUEST]: ({ commit, dispatch}) => {
		commit(ACCOUNT_REQUEST);
		return accountService.getAccountInfo({ url: 'me' })
			.then(response => {
				commit(ACCOUNT_SUCCESS, response);
				return response;//Promise.resolve(response);
			})
			.catch(error => {
				commit(ACCOUNT_ERROR, error);
				return error; //Promise.reject(error);
			});
	},
	[UPDATE_PAYMENT_METHOD]: ({ commit, dispatch}, response) => {
		commit(UPDATE_PAYMENT_METHOD, response);
	},
	[GET_ESTIMATED_TAX]: ({ commit, dispatch}, zip) => {
		// if available in state avoid http request
		if (state.estimatedTax) {
			return state.estimatedTax;
		}
		commit(SET_TAX_LOADING, true);
		return accountService.getEstimatedTax(zip)
			.then(response => {
				commit(SET_ESTIMATED_TAX, response);
				return response;
			})
			.catch(error => {
				console.error(error);
			})
			.finally(()=>{
				commit(SET_TAX_LOADING, false);
			});
	}
};

const mutations = {
	[ACCOUNT_REQUEST]: (state) => {
		state.status = {
			loading: true
		};
	},
	[ACCOUNT_SUCCESS]: (state, response) => {
		state.status = {
			success: true
		};
		Vue.set(state, 'account', response);
	},
	[ACCOUNT_ERROR]: (state, response) => {
		state.status = {
			error: response
		};
	},
	[SET_TAX_LOADING]: (state, payload) => {
		state.loadingTaxInfo = payload;
	},
	[UPDATE_PAYMENT_METHOD]: (state, response) => {
		Vue.set(state.account, 'paymentMethod', response);
	},
	[SET_ESTIMATED_TAX]: (state, response) => {
		state.estimatedTax = response;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/account.js